import React, { useState } from 'react';
import OnboardingIntro from '../../components/OnboardingComponents/OnboardingIntro';
import OnboardingStep from '../../components/OnboardingComponents/OnboardingStep';
import OnboardingFinalStep from '../../components/OnboardingComponents/OnboardingFinalStep';
import './OnboardingPage.css';


/**
 * 
 * NOTE FOR DEVELOPERS: FOR MOW, NO FUNCTIONALITY OF DATABASE HAS BEEN ADDED. THEREFORE, THE FORM DATA IS OUTPUT IN A USABLE JSON FORMAT ON CONSOLE.
 */
const stepsData = [
  {
    subtitle: "Why are you posting on LinkedIn?",
    options: [
      "Networking posts",
      "Building a personal brand",
      "Seeking new job opportunities",
      "Recruiting talent",
      "Sharing professional expertise",
      "Learning new skills",
      "Promoting events or webinars",
      "Researching competitors",
    ],
    showOtherInput: true,
  },
  {
    subtitle: "What do you like to share on LinkedIn?",
    options: [
      "Thought Leadership",
      "Career Tips",
      "Product Launches",
      "Company Updates",
      "Personal stories",
      "Case Studies",
      "Industry News",
      "Event Announcements",
      "Educational Content",
    ],
    showOtherInput: true,
  },
  {
    subtitle: "What's your writing style?",
    options: [
      { label: "Formal", subtext: "Traditional and corporate-friendly" },
      { label: "Casual", subtext: "Relaxed and approachable" },
      { label: "Inspirational", subtext: "Uplifting and motivating" },
      { label: "Analytical", subtext: "Data-focused and detailed" },
      { label: "Conversational", subtext: "Interactive and friendly" },
      { label: "Authoritative", subtext: "Expert and commanding" },
      { label: "Witty", subtext: "Humorous and clever" },
      { label: "Persuasive", subtext: "Convincing and compelling" },
      { label: "Educational", subtext: "Informative and instructive" },
    ],
    showOtherInput: true,
  },
  {
    subtitle: "What's your industry?",
    options: [
      "AI & ML",
      "Coaching",
      "Design",
      "Finance",
      "IT",
      "Marketing",
      "Real Estate",
      "Web3",
    ],
    showOtherInput: true,
  },
  {
    subtitle: "What's your job description?",
    options: [
      "Designer (Graphic, UI/UX, Product)",
      "Executive (CEO, CFO, CTO, etc.)",
      "Developer (Web, Software, Mobile)",
      "Manager (Project, Sales, Marketing)",
      "Analyst (Business, Data, etc.)",
      "Marketing Professional",
      "Consultant",
      "Writer/Editor",
      "Customer Service Representative",
    ],
    showOtherInput: true,
  },
];

const OnboardingPage = () => {
  const [step, setStep] = useState(0);
  const [responses, setResponses] = useState({});
  const [finalNote, setFinalNote] = useState('');

  const goToNextStep = () => setStep((prev) => prev + 1);
  const goToPreviousStep = () => setStep((prev) => prev - 1);

  const handleStepChange = (stepIndex, selectedArray) => {
    setResponses((prev) => ({
      ...prev,
      [`step${stepIndex + 1}`]: selectedArray,
    }));
  };

  const submitFinal = () => {
    const output = {
      ...responses,
      finalNote,
    };
    console.log(JSON.stringify(output, null, 2));
    // You can send this `output` to API if needed
  };

  if (step === 0) {
    return (
      <div className="onboarding-page-wrapper">
        <OnboardingIntro onNext={goToNextStep} />
      </div>
    );
  }

  if (step === stepsData.length + 1) {
    return (
      <div className="onboarding-page-wrapper">
        <OnboardingFinalStep
          stepNumber={step}
          totalSteps={stepsData.length + 1}
          value={finalNote}
          onChange={setFinalNote}
          onBack={goToPreviousStep}
          onNext={() => {
            submitFinal();
          }}
        />
      </div>
    );
  }

  const currentStep = stepsData[step - 1];
  const currentSelections = responses[`step${step}`] || [];

  return (
    <div className="onboarding-page-wrapper">
      <OnboardingStep
        stepNumber={step}
        totalSteps={stepsData.length + 1}
        title="Onboarding"
        subtitle={currentStep.subtitle}
        options={currentStep.options}
        showOtherInput={currentStep.showOtherInput}
        selectedOptions={currentSelections}
        onDataChange={(selected) => handleStepChange(step - 1, selected)}
        onNext={goToNextStep}
        onBack={goToPreviousStep}
      />
    </div>
  );
};

export default OnboardingPage;
